const PanelCallOutIcon = () => {
    return (
        <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect width='24' height='24' rx='12' fill='#FFE3C1' />
            <path
                d='M8.875 20.125H15.125'
                stroke='#090B2A'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M12 17.625V13.25'
                stroke='#090B2A'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M9.5 10.75L12 13.25L14.5 10.75'
                stroke='#090B2A'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.1485 15.0469C7.40444 14.4684 6.8018 13.7281 6.38626 12.8821C5.97071 12.0361 5.75315 11.1066 5.75007 10.1641C5.73444 6.77348 8.461 3.95317 11.8516 3.87505C13.1639 3.84394 14.4526 4.22677 15.535 4.96924C16.6175 5.71171 17.4387 6.77613 17.8822 8.01154C18.3257 9.24696 18.369 10.5906 18.0059 11.852C17.6428 13.1134 16.8918 14.2285 15.8594 15.0391C15.6314 15.2154 15.4466 15.4415 15.3194 15.7001C15.1921 15.9587 15.1256 16.243 15.1251 16.5313V17C15.1251 17.1658 15.0592 17.3248 14.942 17.442C14.8248 17.5592 14.6658 17.625 14.5001 17.625H9.50007C9.33431 17.625 9.17534 17.5592 9.05813 17.442C8.94091 17.3248 8.87507 17.1658 8.87507 17V16.5313C8.87311 16.2452 8.80679 15.9632 8.68101 15.7063C8.55524 15.4493 8.37324 15.224 8.1485 15.0469V15.0469Z'
                stroke='#090B2A'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default PanelCallOutIcon;
